import type { FilterActionsEnum, QuickFilterAction } from '@unifyapps/defs/types/blocks';
import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type { ToolbarVariant } from '@unifyapps/table/types';
import { FilterButton } from './FilterButton';

type QuickFilterProps = QuickFilterAction & {
  onClickQuickFilter?: (id: string, type: FilterActionsEnum) => void;
  isSelected?: boolean;
  variant?: 'solid' | 'outline';
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  startDecorator?: React.ReactNode;
  endDecorator?: React.ReactNode;
  toolbarVariant?: ToolbarVariant;
};

function QuickFilterButton(props: QuickFilterProps) {
  const {
    id,
    label = '',
    onClickQuickFilter,
    isSelected,
    filterType,
    appearance,
    variant = 'outline',
    disabled,
    style,
    className,
    startDecorator,
    endDecorator,
    toolbarVariant,
  } = props;

  const onClick = useEventCallback(() => onClickQuickFilter?.(id, filterType));

  return (
    <FilterButton
      appearance={appearance}
      className={className}
      disabled={disabled}
      endDecorator={endDecorator}
      id={id}
      isSelected={isSelected}
      label={label}
      onClick={onClick}
      startDecorator={startDecorator}
      style={style}
      toolbarVariant={toolbarVariant}
      variant={variant}
    />
  );
}

export default QuickFilterButton;
